import React, { useRef, useState, useEffect, useContext } from "react";
import Accordion from 'react-bootstrap/Accordion';
import AccordionContext from 'react-bootstrap/AccordionContext';
import { useAccordionButton } from 'react-bootstrap/AccordionButton';
import Card from 'react-bootstrap/Card';
import './css/collapse.css';
import plus from "../../../assets/font-awesome/white/png/128/plus.png";

function Preview({ item }) {
  const componentRef = useRef();
  const [fName, setfName] = useState("");

  useEffect(() => {
    console.log(fName)
  }, [fName])

  const PINK = 'rgba(255, 192, 203, 0.6)';
  const BLUE = 'rgba(0, 0, 255, 0.6)';

  function ContextAwareToggle({ children, eventKey, callback }) {
    const { activeEventKey } = useContext(AccordionContext);

    const decoratedOnClick = useAccordionButton(
      eventKey,
      () => callback && callback(eventKey),
    );

    const isCurrentEventKey = activeEventKey === eventKey;

    return (

      <button
        className="btn btn-info btn-sm "
        // style={{ backgroundColor: isCurrentEventKey ? PINK : BLUE }}
        style={{ backgroundColor: isCurrentEventKey ? '#0f7051' : BLUE, backgroundImage: "url(" + plus + ")", backgroundSize: "cover", backgroundSize: '20px', backgroundPosition: 'center', backgroundRepeat: 'no-repeat', width: "30px", height: "30px" }}
        type="button"
        data-toggle="tooltip"
        data-placement="top"
        title="Print"
        onClick={decoratedOnClick}
      >
        {children}
      </button>
    );
  }

  return (
    <Accordion 
    style={{ border: '0px' }}
    >
      <Card>
        <Card.Header>
          <ContextAwareToggle eventKey="0"></ContextAwareToggle>
        </Card.Header>
        <Accordion.Collapse eventKey="0">
          <Card.Body>

            <div className="form-group">
              <label className="form-label">Email (Alternatif)</label>
              <input
                type="email"
                placeholder="Email"
                onChange={(e) => {
                  setfName(e.target.value)
                }}
                id="email2"
                className="form-control"

              />
            </div>

          </Card.Body>
        </Accordion.Collapse>
      </Card>
    </Accordion>
  );
}

export default Preview;


